import { Metadados } from '../classes/Metadados';

export function setEstrutura(estrutura) {
  return {
    type: 'SET_ESTRUTURA',
    estrutura,
  };
}
export function setArtigo(artigo) {
  return {
    type: 'SET_ARTIGO',
    artigo,
  };
}
export function addAnalise(analise) {
  return {
    type: 'ADD_ANALISE',
    analise,
  };
}
export function setStatusAnalise(status) {
  return {
    type: 'SET_STATUS_ANALISE',
    status,
  };
}
export function setStatusEstrutura(status) {
  return {
    type: 'SET_STATUS_ESTRUTURA',
    status,
  };
}
export function setStatusSEO(status) {
  return {
    type: 'SET_STATUS_SEO',
    status,
  };
}
export function setAnaliseSeo(analiseSeo) {
  return {
    type: 'SET_ANALISE_SEO',
    analiseSeo,
  };
}
export function setTokenOpti(tokenOpti) {
  return {
    type: 'SET_TOKEN_OPTI',
    tokenOpti,
  };
}
export function setBlogIdOpti(blogIdOpti) {
  return {
    type: 'SET_BLOG_ID_OPTI',
    blogIdOpti,
  };
}
export function setUsuarioIdOpti(usuarioIdOpti) {
  return {
    type: 'SET_USUARIO_ID_OPTI',
    usuarioIdOpti,
  };
}
export function setResultSeo(resultSeo) {
  return {
    type: 'SET_RESULT_SEO',
    resultSeo,
  };
}
export function setKeyword(keyword) {
  return {
    type: 'SET_KEYWORD',
    keyword,
  };
}
export function guardarMetaDados(meta) {
  return {
    type: 'GUARDAR_META_DADOS',
    meta: new Metadados(meta),
  };
}

// actions.js
export const setUserLoggedIn = user => ({
  type: 'SET_USER_LOGGED_IN',
  payload: user,
});
